import { createApp } from 'vue'
import 'virtual:svg-icons-register'
import store from './store'
import router from './router'
import i18n from './i18n'
import App from './App.vue'
import './assets/css/index.scss'

const app = createApp(App)
app.config.warnHandler = () => null // 警告处理函数, 开发中遇到的警告不在控制台打印
app.use(store).use(router).use(i18n).mount('#app')
